import logo from "./images/mail-logo.png"

export const MailLoginButton = () => {

    const handleLogin = async () => {
        console.log("Войти через Mail.ru")
    }

    return (
        <button
            onClick={handleLogin}
            style={{
                marginTop: "1rem",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "10px 20px",
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "26px",
                fontWeight: "500",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                width: "100%"
            }} disabled={true}>
            <img src={logo} alt="Mail.ru" width="30" height="30" />
            {'Mail.ru'}
        </button>
    )
}
